import { signatureStore } from "@/composables/useSignatureStore";
import {TribesClient} from "@/types/tribes_client.ts";
import {web3} from "@coral-xyz/anchor";

const version = "1.2.0"

export default {
	namespaced: true,
	state: () => {
		let villages = null
		try { villages = JSON.parse(localStorage.getItem(`user_villages:${version}`)) } catch { /* corrupted localStorage */ }

		return {
			world: localStorage.getItem(`active_world:${version}`) ? new web3.PublicKey(localStorage.getItem(`active_world:${version}`)) : null,
			active_village: localStorage.getItem(`active_village:${version}`),
			villages,
			client: null,
			session: null,
			context: null,
			wallet: null,
			needsFogoReconnect: false,
		}
	},
	mutations: {
		clear_user_state(state) {
			state.active_village = null
			state.villages = null
			state.world = null
			state.needsFogoReconnect = false
		},
		// set_wallet(state, wallet) {
		// 	// const uri = "https://nyc.shield.fogo.testnet.fluxrpc.com?key=qKfL2v7Gf1qIm12ynuTdwA"
		// 	// const uri = "https://testnet.atlas.xyz?apikey=a60f3e0b285c14806f77ba6213e3a298287f"

		// 	// console.log("Setting wallet", wallet)
		// 	// state.wallet = wallet
		// 	// state.client = new TribesClient(uri, wallet)
		// 	// if (state.world) {
		// 	// 	console.log("Setting world", state.world)
		// 	// 	state.client.setWorld(state.world)
		// 	// }
		// },
		clear_fogo_session(state) {
			try { if (state.client) state.client.destroy() } catch (e) { console.warn("client destroy failed", e) }
			state.session = null
			state.context = null
			state.wallet = null
			state.client = null
		},
		set_needs_fogo_reconnect(state, value) {
			state.needsFogoReconnect = Boolean(value)
		},
		set_fogo_session(state, data) {
			try { if (state.client) state.client.destroy() } catch (e) { console.warn("client destroy failed", e) }
			state.session = data.session
			state.context = data.context
			state.wallet = data.wallet
			console.log("Fogo session set", data)
			signatureStore.init(data.context.connection)
			state.client = new TribesClient("", state.wallet.wallet, data.context.connection, data.wallet.sendTransaction, state.session)
			if (state.world) {
				console.log("Setting world", state.world)
				state.client.setWorld(state.world)
			}
		},
		set_world(state, world) {
			state.world = world
			if (state.client) state.client.setWorld(world)
			state.active_village = null
			localStorage.setItem(`active_world:${version}`, world)
		},
		set_villages(state, villages) {
			state.villages = villages.sort((a,b) => b.account.totalPoints - a.account.totalPoints)
			localStorage.setItem(`user_villages:${version}`, JSON.stringify(state.villages))
		},
		set_active_village(state, active_village) {
			state.active_village = active_village
			localStorage.setItem(`active_village:${version}`, active_village)
			if (state.client) state.client.refreshUser();
		}
	},
	actions: {
		//
	}
}
